import React from 'react';
import LegalFormsFirstSection from './LegalFormsFirstSection';
import LegalFormsSecondSection from './LegalFormsSecondSection';
import { useParams } from 'react-router-dom';

function LegalForms() {
    const { id } = useParams(); // Capture the 'id' from URL params
    const selectedPlanId = id ? parseInt(id, 10) : null; // Convert 'id' or set it to null

    return (
        <div>
            <LegalFormsFirstSection />
            <LegalFormsSecondSection selectedPlanId={selectedPlanId} />
        </div>
    );
}

export default LegalForms;
